<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>

import axios from '@/axios'
// axios.defaults.baseURL = ''
export default {
  name: "App",
  data() {
    return {
      hospitalInfo: null
    }
  },
  watch: {
    $route(to, from) {
      if (to.path != '/login') {
        let obj = {
          name: to.name,
          title: to.meta.title
        }
        this.$store.commit("addTab", obj);
      }
    },
    '$store.state.hospitalIsUpdate': function(val) {
      if (val) {
        console.log('来了来了来', val)
        if (JSON.parse(sessionStorage.getItem('User'))) {
          this.hospitalInfo = JSON.parse(sessionStorage.getItem('User'))
        } else if (JSON.parse(localStorage.getItem('hospitalInfo'))) {
          this.hospitalInfo = JSON.parse(localStorage.getItem('hospitalInfo'))

        }
        this.setTitleAndFavicon()
      }
      this.hospitalIsUpdate = false
    }
  },
  computed: {
    getLogo() {
      if (this.hospitalInfo && (this.hospitalInfo.hospitalCode || this.hospitalInfo.hospitalId)) {
        // 使用当前时间戳替代原来的版本号
        const timestamp = Date.now();
        return window.baseURL + `/operation/hospitalLogo/thumbnail/${this.hospitalInfo.hospitalCode ? this.hospitalInfo.hospitalCode : this.hospitalInfo.hospitalId}?v=${timestamp}`
      }
    }
  },
  created() {
    this.hospitalInfo = JSON.parse(sessionStorage.getItem('User')) || JSON.parse(localStorage.getItem('hospitalInfo')) || null;
    console.log('4444', this.hospitalInfo)
    this.setTitleAndFavicon();
    },
  methods:{
    setTitleAndFavicon() {
      document.title = this.hospitalInfo?.hospitalName || '华利自在AI诊断平台';
      const favicon = document.querySelector('link[rel~="icon"]');
      if (favicon) {
        favicon.href = this.getLogo || `${process.env.BASE_URL}logo.png`;
        document.head.appendChild(favicon);
      }

    },
    // setShow(){
    //   return axios({method: 'post'}).then(res=>{
    //
    //   })
    // }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
